export enum FeatureToggle {
  PremiumHalfOff = 'ggAiStoreBuilderPremiumHalfOff',
  ZenDropEnabled = 'ggAiStoreBuilderZenDropEnabled',
  ModalystSetupByProductList = 'ggAiStoreBuilderModalystSetupByProductList',
}

export const featureToggleIds: string[] = [
  FeatureToggle.PremiumHalfOff,
  FeatureToggle.ZenDropEnabled,
  FeatureToggle.ModalystSetupByProductList,
];
